import { hasRequiredFields } from '@move-frontend/utils';
import { useNewCardFormContext } from './useNewCardFormContext';
import { usePaymentContext } from '../PaymentContext';

export function useNewCardFormHasRequiredFields() {
	const { watch } = useNewCardFormContext();
	const { isNewCardCVVValid, isNewCardNumberValid } = usePaymentContext();
	const values = watch();

	return (
		hasRequiredFields(values, ['expiryDate', 'creditCardType']) &&
		isNewCardCVVValid &&
		isNewCardNumberValid
	);
}
